import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { getGameList, saveGameAuth, getGameAuth } from '@/api/game';
export default {
  name: 'Datas',
  data: function data() {
    return {
      isIndeterminate: false,
      checkAll: true,
      gameList: [],
      dataAuthorityId: [],
      needConfirm: false,
      checkedGames: []
    };
  },
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  methods: {
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      return;
      // this.authGameEnter()
    },
    all: function all() {
      this.dataAuthorityId = _toConsumableArray(this.authoritys);
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    //   选择
    selectAuthority: function selectAuthority() {
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    handleCheckAllChange: function handleCheckAllChange(value) {
      this.checkAll = value;
      this.checkedGames = [];
    },
    handleCheckedGamesChange: function handleCheckedGamesChange() {
      this.checkAll = false;
    },
    authGameEnter: function authGameEnter() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var gameAuth, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              gameAuth = [];
              if (_this.checkAll) {
                gameAuth = ["-1"];
              } else {
                gameAuth = _this.checkedGames;
              }
              console.log(gameAuth);
              _context.next = 5;
              return saveGameAuth({
                authorityId: _this.row.authorityId,
                games: gameAuth
              });
            case 5:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "设置成功"
                });
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var gameListRs, gameAuth;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getGameList({
              "data-no-all": 1
            });
          case 2:
            gameListRs = _context2.sent;
            _this2.gameList = gameListRs.data.games;
            _context2.next = 6;
            return getGameAuth({
              "authorityId": _this2.row.authorityId
            });
          case 6:
            gameAuth = _context2.sent;
            console.log(gameAuth.data);
            if (gameAuth.data.indexOf(-1) != -1) {
              console.log("a");
              _this2.checkAll = true;
            } else {
              console.log("v");
              _this2.checkAll = false;
              _this2.checkedGames = gameAuth.data;
            }
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};